export const MOBILE_BP = 600;
export const CANONIC_SCREEN_WIDTH = 1440;
export const CANONIC_SCREEN_WIDTH_M = 320;
export const ROOT_FONT_SIZE = 40;

export const EMAIL = "info@indgila.com";
export const IG = "https://www.instagram.com/indgila";



// WEBPACK FOOTER //
// ./consts.js